// Librerias.
import React from 'react';
import { Container } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

// Components Base.
import { Footer } from '../components-base';

// Components Contact.
import ReturnToForms from './ReturnToForms';
import Hero from './Hero';

// Assets.
import support from './assets/img/support.svg';

// Hooks.
import ScrollToTop from '../hooks/scrollToTop';

const PageContactSupportSuccess = () => {
  return (
    <>
      <ScrollToTop />
      <Hero />
      <section className="contact_success">
        <Container>
          <div className="wrapper">
            <img src={support} alt="Support Icon" className="icon img-fluid" />
            <p className="description">
              <span>
                <FormattedMessage
                  id="contact.supportsuccess"
                  defaultMessage="¡Muchas gracias por contactar con nuestro equipo de soporte técnico!"
                />
              </span>
              <FormattedMessage id="contact.supportsuccess-subtitle" defaultMessage="En breve nos comunicaremos con usted…" />
            </p>
            <ReturnToForms to={'../../contact'}>
              <FormattedMessage id="contact.supportsuccess-btn" defaultMessage="Regresar" />
            </ReturnToForms>
          </div>
        </Container>
      </section>
      <Footer />
    </>
  );
};
export default PageContactSupportSuccess;
